import { Box, AspectRatio, Image, Text, Center } from '@chakra-ui/react';
import React from 'react';
import feature1 from '@/assets/images/webp/feature-1.webp';
import feature2 from '@/assets/images/webp/feature-2.webp';
import feature3 from '@/assets/images/webp/feature-3.webp';
import feature4 from '@/assets/images/webp/feature-4.webp';
import Slider from 'react-slick';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { FeaturesProps } from '../DesktopFeatures';

const MobileFeatures: React.VFC<FeaturesProps> = ({ t }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    nextArrow: <ChevronRightIcon _hover={{ color: 'gray.500' }} h="30px" right="0" w="30px" />,
    prevArrow: <ChevronLeftIcon _hover={{ color: 'gray.500' }} h="30px" left="0" w="30px" />,
  };

  return (
    <Box h="500px" overflowX="scroll" position="relative" scrollSnapType="x mandatory" w="100%">
      <Slider {...settings}>
        <Box>
          <Center>
            <Box textAlign="center" w="350px">
              <AspectRatio mx="auto" ratio={9 / 16} w="225px">
                <Image alt={t('3d_mapping_with_fast_map_generation')} src={feature1} />
              </AspectRatio>
              <Text mt="4">{t('3d_mapping_with_fast_map_generation')}</Text>
            </Box>
          </Center>
        </Box>

        <Box>
          <Center>
            <Box textAlign="center" w="350px">
              <AspectRatio mx="auto" ratio={9 / 16} w="225px">
                <Image alt={t('best_in_class_fast_relocalization')} src={feature2} />
              </AspectRatio>
              <Text mt="4">{t('best_in_class_fast_relocalization')}</Text>
            </Box>
          </Center>
        </Box>
        <Box>
          <Center>
            <Box textAlign="center" w="350px">
              <AspectRatio mx="auto" ratio={9 / 16} w="225px">
                <Image alt={t('content_authoring_unleashed_creativity')} src={feature3} />
              </AspectRatio>
              <Text mt="4">{t('content_authoring_unleashed_creativity')}</Text>
            </Box>
          </Center>
        </Box>
        <Box>
          <Center>
            <Box textAlign="center" w="350px">
              <AspectRatio mx="auto" ratio={9 / 16} w="225px">
                <Image alt={t('create_sharing_ar_with_multiplayer_service')} src={feature4} />
              </AspectRatio>
              <Text mt="4">{t('create_sharing_ar_with_multiplayer_service')}</Text>
            </Box>
          </Center>
        </Box>
      </Slider>
    </Box>
  );
};

export default MobileFeatures;
